import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {BlockUserInput} from '../../graphql/generated/types';

/**
 * 사용자 차단
 *
 * Origin: pageNicolasApi.blockUser
 * API: POST /api/v1/store/community/block
 */
export async function postStoreCommunityBlock(
  blockUserInput: BlockUserInput,
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/community/block',
    {
      method: 'POST',
      data: {
        user_uid: blockUserInput.userUid,
        state: blockUserInput.state,
      },
    },
    options
  );
  return response.data;
}
